module.exports = __webpack_public_path__ + "static/media/confetti_mobile_right.e387fcd7.png";